import { Font } from "@react-pdf/renderer";
import {
    FONT_OPEN_SANS_BOLD,
    FONT_OPEN_SANS_REGULAR,
} from "src/components/constants";

let fontsRegistered = false;

export const registerExportFonts = () => {
    if (fontsRegistered) {
        return;
    }

    Font.registerHyphenationCallback((word) => {
        if (!word || word.length <= 24) {
            return [word];
        }

        const chunks = [];

        for (let index = 0; index < word.length; index += 24) {
            chunks.push(word.slice(index, index + 24));
        }

        return chunks;
    });

    Font.register({
        family: "Open Sans",
        fonts: [
            {
                src: FONT_OPEN_SANS_REGULAR,
                fontWeight: 400,
                fontStyle: "normal",
            },
            {
                src: FONT_OPEN_SANS_REGULAR,
                fontWeight: 400,
                fontStyle: "italic",
            },
            {
                src: FONT_OPEN_SANS_BOLD,
                fontWeight: 600,
                fontStyle: "normal",
            },
            {
                src: FONT_OPEN_SANS_BOLD,
                fontWeight: 600,
                fontStyle: "italic",
            },
        ],
    });

    fontsRegistered = true;
};
